import(/* webpackMode: "eager" */ "/home/circleci/whoop-web/apps/shop/app/[country]/[language]/(default)/error.tsx");
